import styled from 'styled-components';

import { colors } from '../../commonStyle';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  height: 200px;
  width: 100%;
  background-color: ${(props) => (props.color ? props.color : colors.primary)};
  align-self: stretch;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-top: 5px;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  cursor: pointer;
  border: none;
`;

export const Text = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${colors.white};
  margin-top: 10px;
  text-transform: uppercase;
`;
